// extracted by mini-css-extract-plugin
export default {"root":"DemoHeaderTitle_root__HfEfv"};